

// --- 广告 / 推荐位（与运营、后端约定一致时可改）---
/** 首页轮播 advert/playing 广告位编码 */
export const BOOK_MALL_BANNER_AD_CODE = 'h5001';

/** 功能胶囊区（新人福利 / 秒杀入口）advert/playing 广告位编码 */
export const BOOK_MALL_FUNCTION_MODULES_AD_CODE = 'h5002';

/**
 * 功能胶囊区广告内容 id（与运营后台 advertisingContentWebInfoRespVOS.id 一致）
 * 1018：新人福利模块；1019：秒杀课程模块；其他 id 不展示对应入口
 */
export const BOOK_MALL_NEW_USER_WELFARE_AD_CONTENT_ID = 12683;
export const BOOK_MALL_SECKILL_COURSE_AD_CONTENT_ID = 12684;

/** 热卖推荐横滑区 home-recommend/info-list 推荐位 ID */
export const BOOK_MALL_HOT_SALE_RECOMMEND_ID = 648;

/** 图书商城列表/搜索历史 推荐位 ID */
export const BOOK_MALL_HOME_RECOMMEND_ID = 647;

/** 四六级考试类型 id（与字典 year 项中「四六级」的 id 一致；仅选四六级、未选其他类型时隐藏科目、图书分类） */
export const CET_EXAM_TYPE_ID = [4,5,6];
